 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"altcoin-stats~charts":"altcoin-stats~charts","altcoin-stats":"altcoin-stats","charts":"charts","analytics":"analytics","audit":"audit","balance-sheet":"balance-sheet","coin-health":"coin-health","coin-health-detail":"coin-health-detail","forgot-password":"forgot-password","kyc":"kyc","market-files":"market-files","market-pos-files":"market-pos-files","marketing":"marketing","merchant-autonomy":"merchant-autonomy","merchant-cc":"merchant-cc","merchant-detail":"merchant-detail","merchant-fees-custom":"merchant-fees-custom","news":"news","not-authorized":"not-authorized","payouts":"payouts","paypal-audit":"paypal-audit","platform-licensing":"platform-licensing","platform-scheduling":"platform-scheduling","platform-scheduling-sql":"platform-scheduling-sql","reports":"reports","roles":"roles","trade-flex":"trade-flex","transaction-detail":"transaction-detail","transaction-ether-pool":"transaction-ether-pool","transaction-scheduling":"transaction-scheduling","transaction-scheduling-tasks":"transaction-scheduling-tasks","transaction-xrp-pool":"transaction-xrp-pool","transactions":"transactions","users":"users","vtokens":"vtokens","xchange-offline-pool":"xchange-offline-pool"}[chunkId]||chunkId) + "." + {"altcoin-stats~charts":"7e5ed3d1","altcoin-stats":"1f87fbb7","charts":"79f57744","analytics":"fa3d7b60","audit":"a4aa9630","balance-sheet":"198068f0","coin-health":"7b86745e","coin-health-detail":"51a1a145","forgot-password":"6b1d1928","kyc":"1a02545a","market-files":"9797b4af","market-pos-files":"ed70560d","marketing":"731e6b3b","merchant-autonomy":"1f186fbe","merchant-cc":"8135ab96","merchant-detail":"968ff302","merchant-fees-custom":"c53b0f50","news":"37156d80","not-authorized":"61ee6a13","payouts":"06e60a4a","paypal-audit":"990cdda6","platform-licensing":"43cdfe2b","platform-scheduling":"a5bc2ee3","platform-scheduling-sql":"2b3df573","reports":"e24dbc5a","roles":"50ef540c","trade-flex":"f4990624","transaction-detail":"5ffb982a","transaction-ether-pool":"c2d0edcc","transaction-scheduling":"3ec10463","transaction-scheduling-tasks":"d28fed4f","transaction-xrp-pool":"c534bc8d","transactions":"5654afa2","users":"113610c0","vtokens":"e0eb1a64","xchange-offline-pool":"4f6338ec"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"analytics":1,"balance-sheet":1,"merchant-detail":1,"transaction-detail":1,"transactions":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"altcoin-stats~charts":"altcoin-stats~charts","altcoin-stats":"altcoin-stats","charts":"charts","analytics":"analytics","audit":"audit","balance-sheet":"balance-sheet","coin-health":"coin-health","coin-health-detail":"coin-health-detail","forgot-password":"forgot-password","kyc":"kyc","market-files":"market-files","market-pos-files":"market-pos-files","marketing":"marketing","merchant-autonomy":"merchant-autonomy","merchant-cc":"merchant-cc","merchant-detail":"merchant-detail","merchant-fees-custom":"merchant-fees-custom","news":"news","not-authorized":"not-authorized","payouts":"payouts","paypal-audit":"paypal-audit","platform-licensing":"platform-licensing","platform-scheduling":"platform-scheduling","platform-scheduling-sql":"platform-scheduling-sql","reports":"reports","roles":"roles","trade-flex":"trade-flex","transaction-detail":"transaction-detail","transaction-ether-pool":"transaction-ether-pool","transaction-scheduling":"transaction-scheduling","transaction-scheduling-tasks":"transaction-scheduling-tasks","transaction-xrp-pool":"transaction-xrp-pool","transactions":"transactions","users":"users","vtokens":"vtokens","xchange-offline-pool":"xchange-offline-pool"}[chunkId]||chunkId) + "." + {"altcoin-stats~charts":"31d6cfe0","altcoin-stats":"31d6cfe0","charts":"31d6cfe0","analytics":"1d153286","audit":"31d6cfe0","balance-sheet":"fed6d51f","coin-health":"31d6cfe0","coin-health-detail":"31d6cfe0","forgot-password":"31d6cfe0","kyc":"31d6cfe0","market-files":"31d6cfe0","market-pos-files":"31d6cfe0","marketing":"31d6cfe0","merchant-autonomy":"31d6cfe0","merchant-cc":"31d6cfe0","merchant-detail":"38ea1736","merchant-fees-custom":"31d6cfe0","news":"31d6cfe0","not-authorized":"31d6cfe0","payouts":"31d6cfe0","paypal-audit":"31d6cfe0","platform-licensing":"31d6cfe0","platform-scheduling":"31d6cfe0","platform-scheduling-sql":"31d6cfe0","reports":"31d6cfe0","roles":"31d6cfe0","trade-flex":"31d6cfe0","transaction-detail":"1c84698d","transaction-ether-pool":"31d6cfe0","transaction-scheduling":"31d6cfe0","transaction-scheduling-tasks":"31d6cfe0","transaction-xrp-pool":"31d6cfe0","transactions":"eaae0c05","users":"31d6cfe0","vtokens":"31d6cfe0","xchange-offline-pool":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
